import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action'
import type { PaymentGatewayObject } from '../PaymentGatewayObject'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'
import { CheckoutBilling } from './CheckoutBilling'
import { CheckoutLineItem } from './CheckoutLineItem'

@InputType()
export class CreateCheckoutSessionArgs {
  @Field(() => String)
  successUrl: string

  @Field(() => String)
  cancelUrl: string

  @Field(() => [CheckoutLineItem])
  lineItems: CheckoutLineItem[]

  // Round-trips through the gateway back to the paid webhook (PayMongo's `reference_number`,
  // Stripe's `metadata`) so the caller can find the record this checkout session settles.
  @Field(() => String)
  reference: string

  @Field(() => GraphQLJSON, { nullable: true })
  metadata?: Record<string, any>

  @Field(() => String, { nullable: true })
  description?: string

  // Absent means "use the app's configured default provider" — present is a caller-chosen
  // override (e.g. a future "pay with Stripe / PayPal" picker).
  @Field(() => String, { nullable: true })
  gatewayProvider?: PaymentGatewayProvider

  // Provider-neutral field on this shared args type; only PayMongo's gateway forwards it
  // today, as the hosted checkout's `billing` prefill. Stripe's gateway deliberately consumes
  // this field rather than passing it through, so it never leaks onto Stripe's wire payload.
  @Field(() => CheckoutBilling, { nullable: true })
  billing?: CheckoutBilling
}

export interface ICreateCheckoutSession extends IAction<PaymentGatewayObject, CreateCheckoutSessionArgs> {}
